import wx from 'weixin-jsapi'
import { api } from 'common/app'
import config from '../config'
// import tools from '@/server'

class WX {
  async getConfig () {
   /* const wxConfig = window.sessionStorage.getItem('wxConfig')
    if (wxConfig === 'success') {
      return this.setReady()
    }*/
    let { data } = await api.getshare({ url:window.location.href.split('#')[0] })
    if (data) {
      this.setWx(data)
    }
  }
  setWx (res) {
    wx.config({
      debug: false,
      appId: res.appid,
      timestamp: res.timestamp,
      nonceStr: res.noncestr,
      signature: res.signature,
      jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
    })
    this.setReady()
    wx.error(function (err) {
      alert(JSON.stringify(err))
    })
  }
  setReady () {
    wx.ready(function () {
      window.sessionStorage.setItem('wxConfig', 'success')

      wx.onMenuShareTimeline({
        title: config.wxShareConfig.title, // 分享标题
        desc: config.wxShareConfig.desc, // 分享描述
        link: window.location.href, // 分享链接
        imgUrl: config.wxShareConfig.imgurl, // 分享图标
        success: function () {
                    //               alert("分享到朋友圈成功")
                    // Toast({
                    // message: "成功分享到朋友圈"
                    // });
        },
        cancel: function () {
                    //               alert("分享失败,您取消了分享!")
                    // Toast({
                    // message: "分享失败,您取消了分享!"
                    // });
        }
      })
            // 微信分享菜单测试
      wx.onMenuShareAppMessage({
        title: config.wxShareConfig.title, // 分享标题
        desc: config.wxShareConfig.desc, // 分享描述
        link: window.location.href, // 分享链接
        imgUrl: config.wxShareConfig.imgurl, // 分享图标
        success: function () {
                    // alert("成功分享给朋友")
                    //              Toast({
                    //                message: "成功分享给朋友"
                    //              });
        },
        cancel: function () {
                    // alert("分享失败,您取消了分享!")
                    //              Toast({
                    //                message: "分享失败,您取消了分享!"
                    //              });
        }
      })

      wx.onMenuShareQQ({
        title: config.wxShareConfig.title, // 分享标题
        desc: config.wxShareConfig.desc, // 分享描述
        link: window.location.href, // 分享链接
        imgUrl: config.wxShareConfig.imgurl, // 分享图标
        success: function () {
                    // alert("成功分享给QQ")
                    //              Toast({
                    //                message: "成功分享到QQ"
                    //              });
        },
        cancel: function () {
                    // alert("分享失败,您取消了分享!")
                    //              Toast({
                    //                message: "分享失败,您取消了分享!"
                    //              });
        }
      })
      wx.onMenuShareWeibo({
        title: config.wxShareConfig.title, // 分享标题
        desc: config.wxShareConfig.desc, // 分享描述
        link: window.location.href, // 分享链接
        imgUrl: config.wxShareConfig.imgurl, // 分享图标
        success: function () {
                    // alert("成功分享给朋友")
                    //              Toast({
                    //                message: "成功分享到腾讯微博"
                    //              });
        },
        cancel: function () {
                    // alert("分享失败,您取消了分享!")
                    //              Toast({
                    //                message: "分享失败,您取消了分享!"
                    //              });
        }
      })
      wx.onMenuShareQZone({
        title: config.wxShareConfig.title, // 分享标题
        desc: config.wxShareConfig.desc, // 分享描述
        link: window.location.href, // 分享链接
        imgUrl: config.wxShareConfig.imgurl, // 分享图标
        success: function () {
                    // alert("成功分享给朋友")
                    //              Toast({
                    //                message: "成功分享到QQ空间"
                    //              });
        },
        cancel: function () {
                    // alert("分享失败,您取消了分享!")
                    //              Toast({
                    //                message: "分享失败,您取消了分享!"
                    //              });
        }
      })
    })
  }
}

export default new WX()



// WEBPACK FOOTER //
// ./src/common/utils/wx.js